import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
// import axiosInstance from "../../Component/axiosInstance";
import axiosInstance from "../../../Component/axiosInstance";
import Cookies from 'js-cookie';

// Async thunk for adding a company
const deleteTransportDetail = createAsyncThunk('transportDetail', async ({deleteid , projectionid}, { rejectWithValue }) => {
    try {
        console.log("yo hai transhport detail function ****************** ",deleteid , projectionid);
        const response = await axiosInstance.delete(`/project/transportdelete`, {
            headers: {
                'x-auth-token': localStorage.getItem('token'),
                'x-projection-id':projectionid,
                'x-deletedata-id':deleteid,
            }
        });
        return response.data;
    } catch (error) {
        return rejectWithValue(error.response?.data?.message || "An unexpected error occurred");
    }
});

// Slice for managing add company state
const deleteTransportDetailSlice = createSlice({
    name: 'deleteTransportDetail',
    initialState: {
        loading: false,
        error: null,
        data: null,
        isSuccess: false,
        isError: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(deleteTransportDetail.pending, (state) => {
                state.loading = true;
                state.error = null;
                state.data = null;
                state.isSuccess = false;
                state.isError = false;
            })
            .addCase(deleteTransportDetail.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action.payload;
                state.isSuccess = true;
                state.isError = false;
            })
            .addCase(deleteTransportDetail.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload || action.error.message;
                state.data = null;
                state.isError = true;
                state.isSuccess = false;
            });
    }
});

export { deleteTransportDetail };
export default deleteTransportDetailSlice.reducer;